import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function AppHeader({ config, isConfigSaved }) {
  const location = useLocation();
  const navigate = useNavigate();

  // Verificar si la configuración está completa
  const isConfigurationComplete = isConfigSaved && config.clientName && config.garmentTypes && config.garmentTypes.length > 0;

  // Función para manejar clic en enlaces deshabilitados
  const handleDisabledClick = (e, path) => {
    if (!isConfigurationComplete && (path === '/' || path === '/documents')) {
      e.preventDefault();
      // Mostrar mensaje de aviso
      alert('Por favor, complete y guarde la configuración inicial antes de acceder a esta sección.');
      // Redirigir a configuración si no está completa
      if (location.pathname !== '/config') {
        navigate('/config');
      }
    }
  };

  return (
    <header className="bg-[#fb2245] h-[70px] flex items-center justify-between px-4 relative -mt-2 -ml-2 -mr-2">
      {/* Logo de la empresa como botón de inicio */}
      <Link 
        to="/" 
        className="flex-shrink-0"
        onClick={(e) => handleDisabledClick(e, '/')}
      >
        <img 
          src="https://assets.brandbay.io/brands/1736547941865x394131539339247600/assets/Y7TrUoiturri%20horizontal%20bl.svg" 
          alt="ITURRI Logo" 
          className="h-12 object-contain" 
        />
      </Link>
      
      {/* Iconos de navegación */}
      <div className="flex gap-4">
        <Link 
          to="/" 
          className={`p-2 rounded-full transition-colors ${
            location.pathname === '/' 
              ? 'bg-[#fb2245] text-white' 
              : isConfigurationComplete 
                ? 'text-white hover:bg-[#d11a38]' 
                : 'text-gray-400 cursor-not-allowed'
          }`}
          title={isConfigurationComplete ? "Inicio" : "Complete la configuración primero"}
          onClick={(e) => handleDisabledClick(e, '/')}
        >
          <SafeIcon icon={FiIcons.FiHome} className="w-6 h-6" />
        </Link>
        
        <Link 
          to="/documents" 
          className={`p-2 rounded-full transition-colors ${
            location.pathname === '/documents' 
              ? 'bg-[#fb2245] text-white' 
              : isConfigurationComplete 
                ? 'text-white hover:bg-[#d11a38]' 
                : 'text-gray-400 cursor-not-allowed'
          }`}
          title={isConfigurationComplete ? "Documentos" : "Complete la configuración primero"}
          onClick={(e) => handleDisabledClick(e, '/documents')}
        >
          <SafeIcon icon={FiIcons.FiFolder} className="w-6 h-6" />
        </Link>
        
        <Link 
          to="/config" 
          className={`p-2 rounded-full transition-colors ${
            location.pathname === '/config' 
              ? 'bg-[#fb2245] text-white' 
              : 'text-white hover:bg-[#d11a38]'
          }`}
          title="Ajustes"
        >
          <SafeIcon icon={FiIcons.FiSettings} className="w-6 h-6" />
        </Link>
      </div>
    </header>
  );
}

export default AppHeader;